"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _reactRouterDom = require("react-router-dom");
var _ReactText = _interopRequireDefault(require("./ReactText01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Button = (0, _component.default)(function () {
  return import("./Button");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});
var ReactText01 = function ReactText01(_ref) {
  var buttonLabel = _ref.buttonLabel,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "de" : _ref$lang,
    text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "body1" : _ref$variant,
    variants = _ref.variants,
    ButtonProps = _ref.ButtonProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var navigate = (0, _reactRouterDom.useNavigate)();
  var css = (0, _ReactText.default)();
  var $text = (0, _react.useRef)(null);
  var handleClick = function handleClick(e, pathname) {
    if (pathname) {
      e.preventDefault();
      navigate(pathname);
    } else {
      return;
    }
  };
  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      var _$text$current;
      var $links = $text === null || $text === void 0 ? void 0 : (_$text$current = $text.current) === null || _$text$current === void 0 ? void 0 : _$text$current.querySelectorAll("a:not([target=_blank]):not([href^='mailto:']):not([href^='tel:'])");
      $links === null || $links === void 0 ? void 0 : $links.forEach(function (link) {
        var pathname = link === null || link === void 0 ? void 0 : link.pathname;
        link === null || link === void 0 ? void 0 : link.addEventListener("click", function (e) {
          return handleClick(e, pathname);
        });
      });
    }, 500);
    return function () {
      return clearTimeout(timer);
    };
  }, []);
  if (!text) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-text-01",
    ref: $text
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: css.text,
    component: "div",
    variant: variant,
    variants: variants
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(_defineProperty({}, css.show, show)),
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), !show && text.indexOf("<span class=\"hidden\">") > -1 && /*#__PURE__*/_react.default.createElement(Button, {
    label: buttonLabel,
    lang: lang,
    setShow: setShow,
    ButtonProps: ButtonProps
  })));
};
ReactText01.propTypes = {
  buttonLabel: _propTypes.default.string,
  lang: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  variant: _propTypes.default.string,
  variants: _propTypes.default.object,
  ButtonProps: _propTypes.default.object
};
var _default = ReactText01;
exports.default = _default;